import { createSlice } from "@reduxjs/toolkit";
import { removeData } from "jquery";

const initialState = {
  users: [],
};
export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    addUser: (state, action) => {
      state.users = [];
      state.users.push(action.payload);
    },
    // removeUser: (state, action) => {
    //   state.users = state.users.filter((user) => user.userid !== action.payload);
    // },

    deleteUser: (state, action) => {
      state.users = state.users.filter((user) => user.userid !== action.payload);
      removeData("users/" + action.payload);
      state.users = [];
    },

    updateUser: (state, action) => {
      state.users = state.users.map((user) => {
        if (user.userid === action.payload.userid) {
          return action.payload;
        }
        return user;
      });
    },
  },
});

export const { addUser, updateUser, deleteUser } = userSlice.actions;

export default userSlice.reducer;
